export default __webpack_public_path__ + "static/media/hht1_ep7_minisitcom_01.ec599630.png";